import { OnboardingWizard } from '@/components/onboarding/OnboardingWizard';
import { SessionGuard } from '@/lib/sessionGuard';

const Onboard = () => {
  return (
    <SessionGuard>
      <OnboardingWizard />
    </SessionGuard>
  );
};

export default Onboard;
